import React from 'react';

import ErrorMessage from '../../../Shared/Components/ErrorMessage';

const Bitpay = ({ serverErrors, handleChange, errors, values }) => {
  return (
    <>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>توکن</label>
          <input
            type='text'
            className='form-control'
            value={values?.api_token}
            name='api_token'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.api_token
                ? serverErrors.api_token
                : errors?.api_token
            }
          />
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>آدرس بازگشت از درگاه</label>
          <input
            type='text'
            className='form-control'
            value={values?.callback_url}
            name='callback_url'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.callback_url
                ? serverErrors.callback_url
                : errors?.callback_url
            }
          />
        </div>
      </div>
    </>
  );
};

export default Bitpay;
